import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { VjPaginatorComponent } from './vj-paginator.component';



@NgModule({
  declarations: [VjPaginatorComponent],
  imports: [
    BrowserModule
  ],
  exports: [VjPaginatorComponent]
})
export class VjPaginatorModule { }
